import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { RoleGuard } from './services/role.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    // canActivate: [RoleGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'view-log',
        loadChildren: () =>
          import('./views/view-log/viewlog.module').then((m) => m.ViewLogModule)
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./views/calendar/calendar.module').then((m) => m.ViewCalendarModule)
      },
      {
        path: 'view-log-pe',
        loadChildren: () =>
          import('./views/view-log-pe/viewlog.module').then((m) => m.ViewLogModule)
      },

    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
